import { getFromLocalStorage } from '@/shared/localStorage/localStorageRepository'

export const getEtagFromLocalStorage = (id: string | number) => {
    const etagData = getFromLocalStorage(id.toString())
    let etag: { eTag: string; requestTime: string; maxAge: string } = {
        eTag: '',
        requestTime: '',
        maxAge: '',
    }

    if (etagData) {
        etag = JSON.parse(etagData)
    }
    return etag
}
